import React from 'react';
import { X } from 'lucide-react';
import '../../styles/CarelonRx/incorrectou.css';

type PharmacyType = 'anthem-bcbs' | 'anthem-bc' | 'wellpoint';

interface IncorrectPathModalProps {
  isOpen: boolean;
  onClose: () => void;
  pharmacyType?: PharmacyType;
}

interface PharmacyData {
  logo: string;
  alt: string;
  description: React.ReactNode;
  url: string;
}

const pharmacyData: Record<PharmacyType, PharmacyData> = {
  'anthem-bcbs': {
    logo: '/assets/carelonRx/images/ABCBS.png',
    alt: 'Anthem Blue Cross Blue Shield',
    description: (
      <>
        If you have an <strong>Anthem Blue Cross and Blue Shield</strong> plan, please visit their website to log in.
      </>
    ),
    url: 'https://www.anthem.com/account-login/'
  },
  'anthem-bc': {
    logo: '/assets/carelonRx/images/ABC.png',
    alt: 'Anthem Blue Cross',
    description: (
      <>
        If you have an <strong>Anthem Blue Cross</strong> plan, please visit their website to log in.
      </>
    ),
    url: 'https://www.anthem.com/ca/account-login/'
  },
  'wellpoint': {
    logo: '/assets/carelonRx/images/Logo_Wellpoint_RGB_100pct.png',
    alt: 'Wellpoint',
    description: (
      <>
        If you have a <strong>Wellpoint</strong> plan, please visit their website to log in.
      </>
    ),
    url: 'https://member.wellpoint.com/public/login'
  }
};

const IncorrectPathModal: React.FC<IncorrectPathModalProps> = ({ 
  isOpen, 
  onClose, 
  pharmacyType = 'wellpoint' 
}) => {
  if (!isOpen) return null;

  const pharmacy = pharmacyData[pharmacyType];

  const handleContinue = () => {
    window.location.href = pharmacy.url;
  };

  return (
    <div className="incorrect-ou-modal-overlay">
      <div className="incorrect-ou-modal-content">
        <div className="incorrect-ou-modal-header">
          <h2>It Looks Like This Isn't the Correct Pharmacy Website for You.</h2>
          <button className="incorrect-ou-modal-close-btn" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        
        <div className="incorrect-ou-modal-body">
          <p>
            To access your pharmacy benefits, please log in to your health plan's website. 
            Once there, bookmark your plan's site for future pharmacy needs.
          </p>
        </div>
        
        <div className="incorrect-ou-pharmacy-card">
          <img 
            src={pharmacy.logo} 
            alt={pharmacy.alt} 
            className="incorrect-ou-pharmacy-logo"
          />
          <p className="incorrect-ou-pharmacy-description">{pharmacy.description}</p>
          <button 
            className="incorrect-ou-pharmacy-button" 
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncorrectPathModal;
